import script from "./VARest.vue?vue&type=script&lang=ts&setup=true"
export * from "./VARest.vue?vue&type=script&lang=ts&setup=true"

import "./VARest.vue?vue&type=style&index=0&id=0aa35d1e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0aa35d1e"]])

export default __exports__